<div class="text-block text-block_margin-bottom_0">
    <div class="text-block__simple-text">
        <strong>Доступно только для владельцев смартфонов на Android</strong>
        <ol>
            <li>Откройте Mir Pay</li>
            <li>Выберите в нижнем меню раздел &laquo;Карты&raquo;</li>
            <li>Выберите нужную карту из списка</li>
            <li>Посмотрите &laquo;Виртуальный номер карты&raquo;</li>
        </ol>
    </div>
</div>
